import { createPdfStyles } from '../utils/create-pdf-styles';

export const styles = createPdfStyles({
  page: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '56px', // See https://github.com/diegomura/react-pdf/issues/774. Fixed footer hack.
    position: 'relative',
  },
  bodyContainer: {
    marginLeft: '48px',
    marginRight: '48px',
  },
  sectionTitle: {
    fontFamily: 'PolySans',
    fontWeight: 500,
    fontSize: '29px',
    color: 'blue.800',
    textAlign: 'left',
    marginVertical: '16px',
    width: '100%',
    marginBottom: '8px',
  },
  section: {
    marginTop: '16px',
    marginBottom: '16px',
    width: '100%',
  },
  pillContainer: {
    borderRadius: 16,
    paddingHorizontal: 8,
    paddingVertical: 4,
  },
  text: {
    fontFamily: 'Open Sans',
    fontSize: '13px',
    color: 'black',
    lineHeight: 1.5,
    fontWeight: '400',
  },
  emphasis: {
    fontWeight: 600,
  },
  topLevelStack: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 16,
  },
});
